import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

import Table_create from "./Table_create";
import Main_Category from "./Main_Category";
import Sub_Cat_form from "./Sub_Cat_form";
import CategoryViewTable from "./Category_view_Tble";

const Cat_Sub_Cat_Create = () => {
  return (
    <Box maxWidth="100%" fontFamily="'Poppins', sans-serif">
      <div className="teacher-list-container">
        <div className="header" style={{ display: "flex", alignItems: "center" }}>
          <h1 style={{ fontSize: "20px", margin: 0 }}>
            Activity Categories
          </h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <Main_Category />
              <Sub_Cat_form />
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link to="/admin" style={{ textDecoration: "none", color: "inherit" }}>
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Co-curricular </span> /{" "}
          <Link to="#" style={{ textDecoration: "none", color: "inherit" }}>
            <span>Activity Categories</span>
          </Link>
        </Box>
      </div>

      <Box p={5} flex="2" mb={9}>
        <Tabs variant="soft-rounded" colorScheme="teal">
          <TabList
            mb={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
            // borderBottom="1px solid #E2E8F0"
            borderRadius="lg"
            // boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
            // _hover={{ boxShadow: "0 8px 12px rgba(0, 0, 0, 0.15)" }}
          >
            <Tab
              _selected={{
                color: "white",
                bg: "teal.500",
                // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                fontWeight: "bold",
                transform: "scale(1.05)",
              }}
              _hover={{
                bg: "teal.100",
                color: "teal.600",
              }}
              px={8}
              py={3}
              borderRadius="md"
              fontSize={useBreakpointValue({ base: "sm", md: "md" })}
              transition="all 0.3s ease"
            >
              Sub-Category
            </Tab>
            <Tab
              _selected={{
                color: "white",
                bg: "teal.500",
                // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                fontWeight: "bold",
                transform: "scale(1.05)",
              }}
              _hover={{
                bg: "teal.100",
                color: "teal.600",
              }}
              px={8}
              py={3}
              borderRadius="md"
              fontSize={useBreakpointValue({ base: "sm", md: "md" })}
              transition="all 0.3s ease"
            >
              Category
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={0} mt="10px">
              <Table_create />
            </TabPanel>

            <TabPanel p={0} mt="10px">
              <CategoryViewTable />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default Cat_Sub_Cat_Create;
